module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Whole Church Sings")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT",
    attrs: {
      "id": "pre001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#pre001"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Luther studies in recent decades have been stimulated by research emanating from the University of Helsinki, usually referred to as the New Finnish Interpretation of Luther."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" These studies challenge many long-held views concerning Luther’s theology and how that theology was practically expressed. Olli-Pekka Vainio, lecturer in systematic theology at Helsinki University, insists that “there is nothing exceptionally Finnish in this particular understanding of the Reformer. . . . If something appears to be new, it is essentially an old treasure, which has been lost, but has now been found again. . . . We do not really ‘interpret’ Luther; we just say what he really meant . . . point[ing] out aspects of the Reformer’s thought that have either been forgotten or neglected for some reason.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("This book similarly attempts to examine what has been either forgotten or neglected about the origins of congregational hymnody in Wittenberg under the leadership of Martin Luther. It challenges some of the conclusions that have been drawn from the available evidence and attempts to provide new perspectives on the old treasure of the earliest Wittenberg hymns.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("But there is a major problem: the available evidence is fragmentary and incomplete. The printed copies of the early Lutheran hymns—individual broadsides, small pamphlets, and the early hymnals—are ephemeral literature; they are either extremely rare or no longer extant.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Consider the following:")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The earliest collection of hymns printed and published in Wittenberg that we are aware of is the set of part-books containing the motets of Johann Walter "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("that appeared toward the end of 1524, but only two of the five part-books are extant, bass and tenor (which mostly contains the chorale melodies). But in some settings the "), _c('i', [_vm._v("cantus firmus")]), _vm._v("—the chorale melody—is not in the tenor voice and therefore inaccessible in one of the lost part-books. Fortunately, two complete sets of the second edition of the part-books, published in Worms in 1525, have survived.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("There are several extant copies of the 1524 collection of hymns published in Erfurt with the title "), _c('i', [_vm._v("Enchiridion")]), _vm._v(", but the Erfurt supplement issued the following year, "), _c('i', [_vm._v("Etliche Christliche Gesenge")]), _vm._v(", was not known until the pioneer Lutheran hymnologist Johann Christoph Olearius reprinted its contents, without music, in 1717,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(" and the original unique copy did not surface from successive private ownership until 1942."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Of the first edition of the extremely important Wittenberg "), _c('i', [_vm._v("Geistliche Lieder")]), _vm._v(" of 1529, there is now no known copy. One apparently still existed in the nineteenth century but has since disappeared."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" A single copy of the earliest later edition of 1533 was not discovered until the early eighteenth century; in 1736 it came into the possession of the Gotha theologian and historian Ernst Solomon Cyprian,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" who reprinted its contents, without music, in 1739."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" Thereafter the single surviving copy remained in private hands until it was obtained in 1932 by the Lutherhalle, Wittenberg, and was eventually issued in facsimile in 1954."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Then there is the single copy of the Wittenberg hymnal of 1526 that forms the focal point of this study, which came to light only at the end of the nineteenth century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])]), _vm._v(" This source has often been noticed in Luther studies but usually as a secondary rather than a primary source. How many other Wittenberg broadsides, pamphlets, and small collections of hymns that at one time existed but have since disappeared remains an enigmatic conundrum.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The title of this book, "), _c('i', [_vm._v("The Whole Church Sings")]), _vm._v(", is based on a statement by "), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Martin Luther in his "), _c('i', [_vm._v("Deutsche Messe")]), _vm._v(", issued in 1526. Because of the fragmentary and incomplete nature of the evidence concerning the extent of congregational participation in hymn singing in these early Reformation years, the tendency in some quarters has been to deny that it was of any significance. The suggestion is that it took some time for congregational singing to be really established in Lutheran worship, that the choir did most of the singing, and that there was no effective congregational hymnal published until 1529. However, it is possible to draw other conclusions from the same documentary sources, from which, if they are also seen against the background of the social and cultural contexts within which the Reformation movement was being played out, a somewhat different picture emerges, as this book attempts to demonstrate.")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("The substance of this study was developed from two keynote addresses. The first I gave at the Lutheran Church–Missouri Synod Institute on Liturgy, Preaching, and Church Music, held at Concordia University, Seward, Nebraska, in July 2014, and the second at the Annual Meeting of the Society for Christian Scholarship in Music, held at Emory University, Atlanta, in February, 2015. I am grateful to the organizers of these events for giving me the opportunity to explore and develop my research interests. For their personal support and encouragement, I sincerely thank my colleagues Stephen Crist of Emory University and Markus Rathey of Yale University. Derek Remeš of Eastman School of Music I gratefully thank for preparing the musical examples. There are three people whose consistent help and assistance have been invaluable; indeed, without it I still would not be finished. Matthew Carver of Nashville has been of enormous help in unraveling linguistic knots in German and Latin in order to create readable and accurate translations—of course, any infelicities in this regard are mine, not his. Daniel Zager, dean of Sibley Library, Eastman School of Music, Rochester, has read every word, sometimes many times; his advice and counsel have materially affected the way this study was completed. And of course, as always, my wife, Sherry Vellucci, has been a source of immense support and encouragement, while at the same time demonstrating patience and forbearance toward her distracted husband; she was also responsible for compiling the indexes.")])]), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Throughout this study a number of conventions have been followed. If the first line of a hymn is cited without reference to an author, it is a hymn by Luther. If the first line of a hymn is given in italics, either the text of the hymn or both text and tune are being referenced; if the first line is given in small capitals, then only the tune with that identity is meant. The spelling "), _c('i', [_vm._v("Enchyridion")]), _vm._v(" (from Greek "), _c('i', [_vm._v("encheiridion")]), _vm._v(", “handbook”) is used to designate the ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Wittenberg hymnal of 1524–26, in order to distinguish it from other collections that have the same title.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Writing about Luther’s hymns for English readers presents a number of problems, not least of which is deciding how to refer to the texts when there are different English versions of the same hymn. And even when the translations appear to be the same in each hymnal, close inspection reveals that they are sometimes variant versions. For example, Luther’s classic hymn “Ein feste Burg ist unser Gott” appears as “A Mighty Fortress Is Our God” in most American hymnals, as “A Safe Stronghold Is Our God” or even “A Fortress Sure Is God and King” in English hymnals, and as “Our God He Is a Castle Strong” in the American edition of "), _c('i', [_vm._v("Luther’s Works")]), _vm._v(" (LW 53:284–85). To attempt to record all these versions within each of the chapters of this book would lead to confusing, cluttered pages. However, the German first lines are not entirely unfamiliar, since they are commonly used in hymnals as the tune names associated with the translated hymn texts. Therefore in the text of this book Luther’s hymns are referred to by their German first lines, but in Appendix 3 they will be found listed alphabetically with information on where they occur in contemporary hymnals in the particular English versions familiar to the reader. In the text the German first lines often follow the spelling and capitalization of the various sources, and they are sometimes given in their Low German versions. However, in the listings of the contents of hymnals, and in the Appendixes, the first lines are given in their modernized High German forms.")]), _vm._v(" "), _c('p', {
    staticClass: "verse-line01"
  }, [_vm._v("“Lob, Ehr sei Gott im höchsten Thron”")]), _vm._v(" "), _c('p', {
    staticClass: "verse-line02"
  }, [_c('i', [_vm._v("Vom Himmel hoch, da komm ich her")]), _vm._v(", stanza 15, line 1")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". See, for example, Olli-Pekka Vainio, ed., "), _c('i', [_vm._v("Engaging Luther: A (New) Theological Assessment")]), _vm._v(" (Eugene, OR: Cascade Books, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Vainio, "), _c('i', [_vm._v("Engaging Luther")]), _vm._v(", vii. This comment resonates with my own approach to Luther studies. My first book, "), _c('i', [_vm._v("Luther on Justification")]), _vm._v(" (St. Louis: Concordia, 1975), was written out of frustration with established Luther studies that conveyed more about what the authors thought about Luther than what Luther himself actually wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". See chap. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Martin von Hase, “Ein Enchiridionfund (Erfurt, Johannes Loersfelt 1525),” "), _c('i', [_vm._v("Archiv für Reformationsgeschichte")]), _vm._v(" 39 (1942): 254–55.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". See chap. 8 and appendix 2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". See “Geleitwort” in the facsimile reprint "), _c('i', [_vm._v("Das Klug’sche Gesangbuch 1533")]), _vm._v(" "), _c('i', [_vm._v("nach dem einzigen erhaltenen Exemplar der Lutherhalle zu Wittenberg")]), _vm._v(", ed. Konrad Ameln (Kassel: Bärenreiter, 1954), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". "), _c('i', [_vm._v("Geistliche Lieder")]), _vm._v(" (Gotha: Reyher, 1739), incorporated into "), _c('i', [_vm._v("Die Hauskirche, oder, erbauliche Schrifften")]), _vm._v(", ed. Ernst Solomon Cyprian (Gotha: Reyher, 1739), [3]:111–80.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". See n. 6 above.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("Enchyridion geistlicher gesenge und psalmen fur die leyen, mit viel andern, denn zuvor, gebessert")]), _vm._v(" (Wittenberg: Lufft, 1526), unique copy in the Staatsbibliothek zu Berlin—Preußischer Kulturbesitz, shelfmark: Libri impr. rari oct. 243.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11292466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 69
// module chunks = 0